import { ETipoUsuario } from "./types";

export enum ECapacidad {
  VerTerminosEnPerfil = "VerTerminosEnPerfil",
  DarseDeBaja = "DarseDeBaja",
  ContinuarSolicitudConsumo = "ContinuarSolicitudConsumo",
  VerReportes = "VerReportes",
  VerSeguros = "VerSeguros",
  VerAutos = "VerAutos",
}

export const CAPACIDADES_POR_PERFIL: Readonly<
  Record<ETipoUsuario, readonly ECapacidad[]>
> = {
  [ETipoUsuario.Interno]: [
    ECapacidad.VerTerminosEnPerfil,
    ECapacidad.ContinuarSolicitudConsumo,
    ECapacidad.VerSeguros,
    ECapacidad.VerAutos,
  ],
  [ETipoUsuario.Agenciero]: [
    ECapacidad.VerTerminosEnPerfil,
    ECapacidad.DarseDeBaja,
    ECapacidad.ContinuarSolicitudConsumo,
    ECapacidad.VerSeguros,
    ECapacidad.VerAutos,
  ],
  [ETipoUsuario.ClienteFinal]: [
    ECapacidad.VerTerminosEnPerfil,
    ECapacidad.DarseDeBaja,
    ECapacidad.ContinuarSolicitudConsumo,
    ECapacidad.VerSeguros,
  ],
  [ETipoUsuario.Productor]: [
    ECapacidad.VerTerminosEnPerfil,
    ECapacidad.DarseDeBaja,
    ECapacidad.ContinuarSolicitudConsumo,
  ],
  [ETipoUsuario.Gestor]: [
    ECapacidad.VerTerminosEnPerfil,
    ECapacidad.DarseDeBaja,
    ECapacidad.ContinuarSolicitudConsumo,
  ],
  [ETipoUsuario.Vendedor]: [
    ECapacidad.DarseDeBaja,
    ECapacidad.ContinuarSolicitudConsumo,
  ],
  [ETipoUsuario.Supervisor]: [ECapacidad.DarseDeBaja, ECapacidad.VerReportes],
};

export function can(tipoUsuario: ETipoUsuario, capacidad: ECapacidad): boolean {
  return CAPACIDADES_POR_PERFIL[tipoUsuario]?.includes(capacidad) ?? false;
}
